import { render, staticRenderFns } from "./LecturerHomepage.vue?vue&type=template&id=49cd2a2c&scoped=true&lang=html&"
import script from "./LecturerHomepage.vue?vue&type=script&lang=js&"
export * from "./LecturerHomepage.vue?vue&type=script&lang=js&"
import style0 from "./LecturerHomepage.vue?vue&type=style&index=0&id=49cd2a2c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cd2a2c",
  null
  
)

export default component.exports